<template>
  <v-img src="@/assets/iql_logo.png" max-width="120"/>
</template>

<script>
export default {
  name: "AppLogo"
}
</script>